module.exports = __webpack_public_path__ + "media/workplace/fast-track-icon-fill-38051d48.svg";